export const COINS = [
  {
    name: '綠籌碼',
    image: 'https://womophoto.s3.ap-northeast-1.amazonaws.com/public/assets/images/coin_m.svg',
    amount: 96,
    title: '綠籌碼．互動用途．免費型',
    description: '免費玩輕社交！互送綠籌碼認識彼此、暖暖互動，還能去合作店領綠籌碼換好康！',
  },
  {
    name: '紅籌碼',
    image: 'https://womophoto.s3.ap-northeast-1.amazonaws.com/public/assets/images/coin_w.svg',
    amount: 12,
    title: '紅籌碼．支持用途．付費型',
    description: '喜歡誰，想挺誰，就買他的紅籌碼吧！籌碼主能分潤，你也能解鎖他的專屬特權！',
  },
  {
    name: '金籌碼',
    image: 'https://womophoto.s3.ap-northeast-1.amazonaws.com/public/assets/images/coin_womo.svg',
    amount: 980,
    title: '金籌碼．購物用途．付費型',
    description: '解鎖功能、兌換虛寶，甚至買下所有人的紅籌碼？只要使用金籌碼，通通能辦到！',
  },
];
